import Navbar from "./components/Navbar";
import Corpo from "./components/Corpo";
import FundoMobile from "./components/FundoMobile";

export default function App() {
    return (
        <>
            <Navbar />
            <Corpo />
            <FundoMobile />    
        </> 
    );
}